import { useBaseAPI } from 'apiServices/baseAPI';
import { oids, endpoints, currentMode } from 'configs';

export function useTimelineAPI({
  resourceId,
  organizationId,
  timeInit,
  timeEnd,
  purposeOfUse,
  subjectId,
  type,
  subjectToken,
}) {
  return useBaseAPI({
    method: 'GET',
    route: `${endpoints.MHD.split(`${endpoints.XDSB_domain}/`)[1]}/DocumentReference?_count=5&subject:Patient.identifier=urn:oid:${resourceId.length === 11 ? oids.cpf : oids.cns}%7C${resourceId}&status=current&format=tdd,${oids.documentPdf}${type || ''}&_count=5&_sort=-period${timeInit ? `&hora=gt${timeInit}` : ''}${timeEnd ? `&hora=lt${timeEnd}` : ''}`,
    additionalHeaders: {
      purposeofuse: purposeOfUse || 'Atendimento',
      ...(organizationId && { 'organization-id': organizationId }),
      ...(subjectId && { 'subject-id': subjectId }),
      ...(resourceId && currentMode === 'aghu' && { 'resource-id': resourceId }),
      ...(subjectToken && { authorization: `Bearer ${subjectToken}` }),
      ...(subjectToken && { 'x-user-token': subjectToken }),
    },
  }, !resourceId);
}
